import { CreditCardImage } from 'components/creditCardImage/creditCardImage';
import { DisplayInfo } from 'components/displayInfo/displayInfo';

import template from './displayBillingAndPayment.html';
import './displayBillingAndPayment.scss';

export const DisplayBillingAndPayment = angular
    .module('checkout.components.displayBillingAndPayment', [
        CreditCardImage,
        DisplayInfo
    ]).component('displayBillingAndPayment', {
        template,
        bindings: {
            cartAddress: '<',
            orderPlacedBy: '<',
            paymentMethod: '<',
            creditCardType: '<',
            creditCardLastFour: '<',
            paypalEmail: '<',
            paymentRequests: '<'
        },
        controller: class DisplayBillingAndPaymentCtrl {
            $onInit() {
                if (this.cartAddress) {
                    this.address = this.cartAddress;
                } else if (this.orderPlacedBy) {
                    this.address = this.orderPlacedBy.address;
                    this.address.firstName = this.orderPlacedBy.firstName;
                    this.address.lastName = this.orderPlacedBy.lastName;
                    this.address.country = this.orderPlacedBy.address.country;
                }
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/displayBillingAndPayment/displayBillingAndPayment.js